// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1854":"ecde68c2462b77bd","6535":"54f0f14b25b98772"}[chunkId] + ".js";
};